<template>
<m-pageframe
    v-if="savepoint != null"
    :title="savepoint.label"
>
<v-container
    fluid
>
    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickStartRollback('rollback')"
                >
                    <v-list-item-title>Reverse changes...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickStartRollback('reapply')"
                >
                    <v-list-item-title>Re-apply changes...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
         <template v-slot:item.time_date="{ item }">
            {{$rc.pretty(item.time,'date')}}
        </template>

        <template v-slot:item.time_time="{ item }">
            {{$rc.pretty(item.time,'time')}}
        </template>

        <template v-slot:item.before_label="{ item }">
            <span v-html="labelHtml(item.before_label, item.current_label)"/>
        </template>

         <template v-slot:item.after_label="{ item }">
            <span v-html="labelHtml(item.after_label, item.current_label)"/>
         </template>

         <template v-slot:item.current_label="{ item }">
            <span v-html="labelHtml(item.current_label, item.current_label)"/>
         </template>

          <template v-slot:item.current_label="{ item }">
            <span v-html="labelHtml(item.current_label, item.current_label)"/>
         </template>

         <template v-slot:item.before_endpoints="{ item }">
            <span v-html="endpointsHtml(item.before_endpoints, item.current_endpoints)"/>
         </template>

          <template v-slot:item.after_endpoints="{ item }">
            <span v-html="endpointsHtml(item.after_endpoints, item.current_endpoints)"/>
         </template>

         <template v-slot:item.current_endpoints="{ item }">
            <span v-html="endpointsHtml(item.current_endpoints, item.current_endpoints)"/>
         </template>

    </v-data-table>
    
    <br/>
    <b>Bold values</b> indicate that the value is current.

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            full_text: null,
            savepoint: null,
            results: [],

            headers: [
                { text: 'Date', value: 'time_date'},
                { text: 'Date', value: 'time_time'},

                { text: 'Label (before)', value: 'before_label'},
                { text: 'Label (after)', value: 'after_label'},
                { text: 'Label (current)', value: 'current_label'},

                { text: 'Numbers (before)', value: 'before_endpoints'},
                { text: 'Numbers (after)', value: 'after_endpoints'},
                { text: 'Numbers (current)', value: 'current_endpoints'},
            ],
        }
    },

    mounted () {
        this.loadSavepoint();
        this.doUpdate()
    },

    methods: {
        loadSavepoint() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/contacts/savepoint',
            
                'params' : {
                        'savepoint_id': this.$route.params.savepoint_id,
                    },
            
                'on_success': (data) => {
                        this.savepoint = data.results[0];
                    },
            
                'on_error': 'Unable to get savepoint',
            });
        },

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/contacts/savepoint/entries',
            
                'params' : {
                        'savepoint_id': this.$route.params.savepoint_id,
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to search contact changes',
            });
        },

        labelHtml(value, current)
        {
            let label = value;
            if ( label == null ) label = '<i>none</i>';

            if ( value == current )
            {
                label = '<b>'+label+'</b>';
            }

            return label;
        },

        endpointsHtml(value, current)
        {
            if ( value == null || value.length == 0 )
            {
                let label = '<i>none</i>';
                
                if ( current == null )
                {
                    label = '<b>'+label+'</b>';
                }

                return label;
            }
            else
            {
                let label = this.$rc.pretty(value, 'endpoints');

                if ( _.isEqual(value,current) )
                {
                    label = '<b>'+label+'</b>';
                }

                return label;
            }
        },

        onClickStartRollback(direction)
        {
            let title = 'Reverse changes';
            let body = 'This will reverse all changes made to contacts by this bulk change.';

            if ( direction == 'reapply' )
            {

                title = 'Re-apply Changes';
                body = 'This will re-apply all changes made to contacts by this bulk change.';
            }

            this.$rc.confirm({
                'title': title,
                'body': body,
                'btn_text_ok': 'Proceed',
                'btn_text_cancel': 'Cancel',
                'text_to_confirm_message': 'To proceed, type "proceed" below.',
                'text_to_confirm': 'proceed',
                'on_ok': () => {
                    this.doRollback(direction);
                },
            });
        },

        doRollback(direction)
        {
            this.$rc.showSpinner((direction == 'rollback' ? 'Reversing' : 'Re-applying')+' contact changes, this can take several minutes...');

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/contacts/savepoint/rollback',
            
                'params' : {
                        'savepoint_id': this.$route.params.savepoint_id,
                        'direction': direction,
                    },
            
                'on_success': (data) => {
                        let process_id = data.process_id;
                        let checks_remaining = 601; // 10 minutes...

                        this.onCheckProgress(process_id, checks_remaining, direction);
                    },
            
                'on_error': 'Unable to '+(direction == 'rollback' ? 'reverse' : 're-apply')+' contact changes',
            });
        },

        onCheckProgress(process_id, checks_remaining, direction)
        {
            if ( checks_remaining < 0 )
            {
                this.$rc.hideSpinner();
                this.$rc.alert((direction == 'rollback' ? 'Reverse' : 'Re-apply')+' contact changes failed', 'Unable to complete operation.  Please try again');
                return;
            }

            checks_remaining--;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/async-process/:process_id',
            
                'params' : {
                        'process_id': process_id,
                    },
            
                'on_success': (data) => {
                        if ( data.state == 'finished' )
                        {
                            this.$rc.hideSpinner();

                            if ( data.outcome == 'fail' )
                            {
                                this.$rc.alert('Change failed', 'An error prevented these changes from being applied');
                                return;
                            }

                            let count_deleted = data.output.count_deleted;
                            let count_upsert = data.output.count_upsert;

                            this.doUpdate();

                            this.$rc.alert('Change made', 'This change to contacts has been made.<br/><br/>Contacts deleted: '+count_deleted+", Contacts created / updated: "+count_upsert);
                        }
                        else
                        {
                            // Still running...
                            window.setTimeout(
                                () => {
                                    this.onCheckProgress(process_id, checks_remaining, direction);
                                },
                                1000
                            )
                        }
                    },
            
                'on_error': 'Unable to apply the contact changes',
            });
        },
    
    },
}
</script>

<style lang="scss" scoped>
</style>